import { render, staticRenderFns } from "./EditBulletin.vue?vue&type=template&id=2b9ddc61&"
import script from "./EditBulletin.vue?vue&type=script&lang=js&"
export * from "./EditBulletin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports